import '../../../../../styles/skelton/client-payment-skeleton.scss';
const ClientPaymentSkeleton = () => {
  return (
    <div className="cf-client-payment-skeleton">
      {/* Cards */}
      <div className="cf-client-payment-skeleton__card-grid">
        {[1, 2].map((item) => (
          <div className="cf-client-payment-skeleton__card" key={item}>
            <div className="cf-client-payment-skeleton__shimmer cf-client-payment-skeleton__icon" />

            <div className="cf-client-payment-skeleton__content">
              <div className="cf-client-payment-skeleton__shimmer cf-client-payment-skeleton__title" />
              <div className="cf-client-payment-skeleton__shimmer cf-client-payment-skeleton__value" />
              <div className="cf-client-payment-skeleton__shimmer cf-client-payment-skeleton__subtitle" />
            </div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="cf-client-payment-skeleton__table">
        <div className="cf-client-payment-skeleton__shimmer cf-client-payment-skeleton__table-header" />

        {[1, 2, 3, 4, 5].map((row) => (
          <div className="cf-client-payment-skeleton__row" key={row}>
            <div className="cf-client-payment-skeleton__shimmer cf-client-payment-skeleton__cell cf-client-payment-skeleton__cell--sm" />
            <div className="cf-client-payment-skeleton__shimmer cf-client-payment-skeleton__cell cf-client-payment-skeleton__cell--md" />
            <div className="cf-client-payment-skeleton__shimmer cf-client-payment-skeleton__cell" />
            <div className="cf-client-payment-skeleton__shimmer cf-client-payment-skeleton__cell" />
            <div className="cf-client-payment-skeleton__shimmer cf-client-payment-skeleton__cell" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientPaymentSkeleton;
